export default __webpack_public_path__ + "static/media/totalpostlogistic.306dc9fa.ico";